import { render, staticRenderFns } from "./StatsReporting.vue?vue&type=template&id=59a8be52&scoped=true&lang=pug&"
import script from "./StatsReporting.vue?vue&type=script&lang=js&"
export * from "./StatsReporting.vue?vue&type=script&lang=js&"
import style0 from "./StatsReporting.vue?vue&type=style&index=0&id=59a8be52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a8be52",
  null
  
)

export default component.exports